import React from 'react';
import { Layout } from 'element-react';

//TEXT for the Badge
//<text id="_1" data-name="1" transform="translate(1352 52)" fill="#fff" font-size="14" font-family="Poppins-SemiBold, Poppins" font-weight="600"><tspan x="0" y="0">1</tspan></text>
const ShoppingCartIcon = (props) => {
  return (
    <div className="flex-column">
        <Layout.Row type="flex" justify="center" align="middle">
            <Layout.Col style={{width: '60%'}} offset="6" span="20">
                {
                   <svg xmlns="http://www.w3.org/2000/svg" width="28.806" height="25.294" viewBox="0 0 700 512" >
                   <path d="M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z" transform="translate(-60px, 10px)" fill="#c1ccd7"/></svg>
                }
                
            </Layout.Col>
            <Layout.Col span="24">
                <div className="header-icon-text">{props.text}</div>
            </Layout.Col>
        </Layout.Row>
    </div>
  )
}

export default ShoppingCartIcon;